const theme = {
    primary: {
        600: '#363636',
        900: '#f1f1f1',
    },
    grey: { 300: '#818181' },
    white: '#fff',
    green: {
        300: '#2c7a7b',
    },
    scrollbar: {
        border: '#ffffff',
        thumb: {
            bg: '#e1e1e1',
        },
    },
    loader: {
        teal: '#5DDADB',
        purple: '#3437A2',
        pink: '#F78EB6',
        bg: '#171923db',
    },
    gradient: {
        blue: {
            300: '#696969',
            600: '#696969',
            900: '#051937',
        },
    },

    text: {
        grey: {
            300: '#939393',
            500: '#ffffff',
        },
    },

    timeline: {
        divider: {
            bg: '#0050cb',
        },
    },
};

export default theme;
